export const enum PaymentStatus {
  SUCCESS = 'SUCCESS',
}
